import * as mutationTypes from './mutationTypes'

export default {
  [ mutationTypes.SET_RECENTLY_ADDED_USERS_LOADING ] (state, loading) {
    state.recentlyAddedUsersLoading = loading
  },

  [ mutationTypes.SET_RECENTLY_ADDED_USERS ] (state, payload) {
    state.recentlyAddedUsersLoading = false
    if (Array.isArray(payload)) {
      state.recentlyAddedUsers = payload
    } else {
      state.recentlyAddedUsers = []
      state.recentlyAddedUsersMessage = payload.userMessage
    }
  },

  [ mutationTypes.SET_RECENTLY_UPDATED_USERS_LOADING ] (state, loading) {
    state.recentlyUpdatedUsersLoading = loading
  },

  [ mutationTypes.SET_RECENTLY_UPDATED_USERS ] (state, payload) {
    state.recentlyUpdatedUsersLoading = false
    if (Array.isArray(payload)) {
      state.recentlyUpdatedUsers = payload
    } else {
      state.recentlyUpdatedUsers = []
      state.recentlyUpdatedUsersMessage = payload.userMessage
    }
  },

  [ mutationTypes.SET_PENDING_USERS_LOADING ] (state, loading) {
    state.pendingUsersLoading = loading
  },

  [ mutationTypes.SET_PENDING_USERS ] (state, payload) {
    state.pendingUsersLoading = false
    if (Array.isArray(payload)) {
      state.pendingUsers = payload
    } else {
      state.pendingUsers = []
      state.pendingUsersMessage = payload.userMessage
    }
  }
}
